import { Users } from "./../models/users";
import { Imybook } from "./../models/mybook";
import { Injectable } from "@angular/core";
import { AngularFirestore, AngularFirestoreCollection } from "angularfire2/firestore";
import * as firebase from "firebase/app";
import { Observable } from "rxjs";
import { IBook } from "../models/book";
import { map } from "rxjs/operators";
import { Events } from "ionic-angular";
import { IPlan } from "../models/plan";
import { IUserSubData } from "../models/userData";
import { ImybookMarks } from "../models/myBookMarks";
import { ImyBookHighlight } from "../models/myBookHighlight";
import { ITerm } from "../models/term";

@Injectable()
export class FirebaseService {
  private itemsCollectionMyBooks: AngularFirestoreCollection<Imybook>; //Firestore collection
  private itemsMyBooks: Observable<Imybook[]>;

  private itemsCollectionBooksCatalog: AngularFirestoreCollection<IBook>; //Firestore collection
  private itemsBooksCatalog: Observable<IBook[]>;

  private itemsCollectionUsersData: AngularFirestoreCollection<IUserSubData>; //Firestore collection
  private itemsUserData: Observable<IUserSubData[]>;

  private itemsCollectionPlanData: AngularFirestoreCollection<IPlan>; //Firestore collection
  private itemsPlanData: Observable<IPlan[]>;

  private itemsCollectionTermData: AngularFirestoreCollection<ITerm>; //Firestore collection
  private itemsTermData: Observable<ITerm[]>;

  private itemsCollectionbookmarksData: AngularFirestoreCollection<ImybookMarks>; //Firestore collection
  private itemsbookmarksData: Observable<ImybookMarks[]>;

  private itemsCollectionHighlightData: AngularFirestoreCollection<ImyBookHighlight>; //Firestore collection
  private itemsHighlightData: Observable<ImyBookHighlight[]>;


  constructor(public afs: AngularFirestore, public events: Events) {}

  // ************************** GESTIONE PIANI ABBONAMENTO ******************************************

  GetPlanData(): Observable<IPlan[]> {
    this.itemsCollectionPlanData = this.afs.collection("plan");
    this.itemsPlanData = this.itemsCollectionPlanData.valueChanges();

    return this.itemsPlanData.pipe(
      map((res: IPlan[]) => {
        return res;
      })
    );
  }

  // ************************** GESTIONE FEEDBACK ******************************************

  AddFeedback(title: string, description: string, type: string) {
    let currentDate = new Date();
    let currentUser = firebase.auth().currentUser;
    let collection: string = "feedback";

    this.afs.collection(collection).add({
      // payment_type: UserDataSub.payment_type,
      date: currentDate.toISOString(),
      user: currentUser.email,
      userid: currentUser.uid,
      title: title,
      description: description,
      type: type
    }).then(function () {
      console.log("Document successfully written!");
    })
      .catch(function (error) {
        console.error("Error writing document: ", error);
      });
  }

  // ************************** GESTIONE PROPRIA LIBRERIA ******************************************

  /**
   * Recupera la lista dei libri che l'utente ha aggiunto
   * @returns Array di libri della mia libreria
   */
  getMybook(): Observable<Imybook[]> {
    let currentUser = firebase.auth().currentUser;

    this.itemsCollectionMyBooks = this.afs
      .collection("UserData")
      .doc(currentUser.uid)
      .collection("Books");
    this.itemsMyBooks = this.itemsCollectionMyBooks.valueChanges();

    return this.itemsMyBooks.pipe(
      map((res: Imybook[]) => {
        //Salva nella local storage i libri
        res.sort((a, b) => new Date(b.last_view_date).getTime() - new Date(a.last_view_date).getTime());
        localStorage.setItem("mybooks", JSON.stringify(res));
        return res;
      })
    );
  }

  /**
   * Aggiunge il libro alla libreria
   * @param book Libro da aggiungere
   */
  AddMyBook(book: IBook, ePubLocal: string, imgLocal: string) {
    let currentDate = new Date();

    let currentUser = firebase.auth().currentUser;
    this.afs
      .collection("UserData")
      .doc(currentUser.uid)
      .collection("Books")
      .doc(book.id)
      .set({
        fontfamily: "Palatino",
        fontsize: "1.9000000000000002",
        color: "white",
        current_page: 1,
        last_view_date: currentDate.toISOString(),
        id: book.id,
        title: book.title,
        imgurl: book.imgurl,
        description: book.description,
        shortdescription: book.shortdescription,
        ISBN: book.ISBN,
        autor: book.autor,
        publisher: book.publisher,
        translator: book.translator,
        month: book.month,
        year: book.year,
        pages: book.pages,
        n_val: book.n_val,
        mid_val: book.mid_val,
        ePubUrl: book.ePubUrl,
        ePubLocal: ePubLocal,
        imgLocal: imgLocal
      }).then(function () {
        console.log("Document successfully written!");
      })
      .catch(function (error) {
        console.error("Error writing document: ", error);
      });

    this.events.publish("mybook:POST-OK", "Libro aggiunto con successo!");
    console.log("Libro aggiunto con successo!");
  }
  /**
   * Aggiorna i dati inerenti al libro che si ha appena chiuso (Colore,font,ultima pagina,ecc...)
   * @param book Libro da aggrionare
   */
  UpdateMyBook(book: Imybook) {
    return new Promise<any>((resolve, reject) => {
      try {
        const currentDate = new Date();
        let currentUser = firebase.auth().currentUser;

        this.afs
          .collection("UserData")
          .doc(currentUser.uid)
          .collection("Books")
          .doc(book.id)
          .set({
            fontfamily: book.fontfamily,
            fontsize: book.fontsize.replace('em',''),
            color: book.color,
            current_page: book.current_page,
            last_view_date: currentDate.toISOString(),
            id: book.id,
            title: book.title,
            imgurl: book.imgurl,
            description: book.description,
            shortdescription: book.shortdescription,
            ISBN: book.ISBN,
            autor: book.autor,
            publisher: book.publisher,
            translator: book.translator,
            month: book.month,
            year: book.year,
            pages: book.pages,
            n_val: book.n_val,
            mid_val: book.mid_val,
            ePubUrl: book.ePubUrl,
            ePubLocal: "",
            imgLocal: book.imgurl,
            status: book.status ? book.status: ""
          })
          .then(res => resolve(res), err => reject(err));
      } catch (error) {
        console.error(error);
      }
    });
  }
  /**
   * Elimina il Libro dalla propria libreria
   * @param book
   */
  RemoveMyBook(book: Imybook) {
    return new Promise<any>((resolve, reject) => {
      let currentUser = firebase.auth().currentUser;
      this.afs
        .collection("UserData")
        .doc(currentUser.uid)
        .collection("Books")
        .doc(book.id)
        .delete()
        .then(res => resolve(res), err => reject(err));
    }).then(function () {
      console.log("Document successfully written!");
    })
      .catch(function (error) {
        console.error("Error writing document: ", error);
      });
  }

  // ************************** GESTIONE CATALOGO ONLINE ******************************************

  /**
   * Recupera la lista dei Libri publicati nel catalogo
   * @returns Array di libri
   */
  getBook(): Observable<IBook[]> {
    this.itemsCollectionBooksCatalog = this.afs.collection("Books");
    this.itemsBooksCatalog = this.itemsCollectionBooksCatalog.valueChanges();

    return this.itemsBooksCatalog.pipe(
      map((res: IBook[]) => {
        return res;
      })
    );
  }

/**
 * Aggiunge il libro al catalogo Online
 */
getCollanaOnlineCatalog(books: IBook[]){

  let ListCollana: string[] = [''];

    books.forEach(book => {

      if (ListCollana.find(item => item === book.collana)) {
      console.log('collana trovata');

      }else{
        console.log('collana trovata');
        ListCollana.push(book.collana);
      }

      ListCollana.shift();

});
  return ListCollana;
}


  //-----------------------------------------------------------------------------------------------------------
  /**
   * Aggiunge il libro al catalogo Online
   */
  scriviBook() {
    let uidBooks = this.afs.collection("Books").add({
      title: "Libro 2",
      imgurl: "https://firebasestorage.googleapis.com/v0/b/fcreder.appspot.com/o/cover%2F612249242.jpg?alt=media&token=faad3772-8c61-4fc2-95c8-8b63a651290b",
      description: "prova descrizionec lunga del libro 2",
      short_description: "prova desc2",
      ISBN: 987654321,
      autor: "Pippo",
      publisher: "Fede e Cultura",
      translator: "Pietro",
      month: "Gennaio",
      year: 2017,
      pages: 50,
      n_val: 0,
      mid_val: 0,
      ePubUrl: ""
    });

    //Aggiorna il libro con l'id
    uidBooks.then(res => {
      // console.log("uidbooks: " + res.id);
      res.update({ id: res.id });
    });
  }

  //-----------------------------------------------------------------------------------------------------------

  // ************************** GESTIONE DATI UTENTE ONLINE ******************************************

  /**
   *Recupera le informazioni dell'utente loggato
   *
   * @param {IUserSubData} user
   * @returns {Observable<IUserSubData[]>}
   * @memberof FirebaseService
   */
  GetUserData(): Observable<IUserSubData[]> {
    let currentUser = firebase.auth().currentUser;

    this.itemsCollectionUsersData = this.afs
      .collection("UserData")
      .doc(currentUser.uid)
      .collection("SubscriptionsData");
    this.itemsUserData = this.itemsCollectionUsersData.valueChanges();

    return this.itemsUserData.pipe(
      map((res: IUserSubData[]) => {
        return res;
      })
    );
  }

  /**
   * Scrive in Firebase i dati delle subscription
   *
   * @param {Users} UserDataSub
   * @memberof FirebaseService
   */
  SetUserData(UserDataSub: Users) {
    let currentUser = firebase.auth().currentUser;
    this.afs
      .collection("UserData")
      .doc(currentUser.uid)
      .collection("SubscriptionsData")
      .add({
        // payment_type: UserDataSub.payment_type,
        reg_date: UserDataSub.reg_date,
        renewal_date: UserDataSub.renewal_date,
        period: UserDataSub.period,
        payment_date: UserDataSub.payment_date,
        cost: UserDataSub.cost
      }).then(function () {
        console.log("Document successfully written!");
      })
      .catch(function (error) {
        console.error("Error writing document: ", error);
      });
  }

  /**
  * Scrive in Firebase i dati delle subscription
  *
  * @param {Users} UserDataSub
  * @memberof FirebaseService
  */
  SetUserDataAccess(email: string) {
    let currentUser = firebase.auth().currentUser;
    let CurrentDate = new Date(Date.now()).toString();

    console.log(CurrentDate);

    this.afs
      .collection("STAT")
      .doc(currentUser.uid)
      .set({
        user: email,
        lastaccess: CurrentDate

      }).then(function () {
        console.log("Document successfully written!");
      })
      .catch(function (error) {
        console.error("Error writing document: ", error);
      });
  }

   /**
     *Recupera il testo delle condizioni
     *
     * @returns {Observable<IUserSubData[]>}
     * @memberof FirebaseService
     */
     getTerm(): Observable<ITerm[]> {
     // let currentUser = firebase.auth().currentUser;
  
      this.itemsCollectionTermData = this.afs
        .collection("Term")
        .doc("term")
        .collection("term");
      this.itemsTermData = this.itemsCollectionTermData.valueChanges();
  
      return this.itemsTermData.pipe(
        map((res: ITerm[]) => {
          return res;
        })
      );
    }

  /**
     *Recupera le informazioni dell'utente loggato
     *
     * @param {IUserSubData} user
     * @returns {Observable<IUserSubData[]>}
     * @memberof FirebaseService
     */
  getBookmarksByBookId(bookid:string): Observable<ImybookMarks[]> {
    let currentUser = firebase.auth().currentUser;

    this.itemsCollectionbookmarksData = this.afs
      .collection("UserData")
      .doc(currentUser.uid)
      .collection("Books")
      .doc(bookid)
      .collection("Bookmarks");
    this.itemsbookmarksData = this.itemsCollectionbookmarksData.valueChanges();

    return this.itemsbookmarksData.pipe(
      map((res: ImybookMarks[]) => {
        return res;
      })
    );
  }

  /**
  * Elimina il Libro dalla propria libreria
  * @param book
  */
  RemoveMybookmarks(book: ImybookMarks) {
    return new Promise<any>((resolve, reject) => {
      let currentUser = firebase.auth().currentUser;
      this.afs
        .collection("UserData")
        .doc(currentUser.uid)
        .collection("Books")
        .doc(book.bookid)
        .collection("Bookmarks")
        .doc(book.id)
        .delete()
        .then(res => resolve(res), err => reject(err));
    }).then(function () {
      console.log("Document successfully written!");
    })
      .catch(function (error) {
        console.error("Error writing document: ", error);
      });
  }

  /**
  * Aggiorna i dati inerenti al libro che si ha appena chiuso (Colore,font,ultima pagina,ecc...)
  * @param book Libro da aggrionare
  */
  UpdateMybookmarks(book: ImybookMarks) {
    return new Promise<any>((resolve, reject) => {
      try {
        let currentDate = new Date();
        let currentUser = firebase.auth().currentUser;
      let newID:string = this.afs.createId();
        this.afs
          .collection("UserData")
          .doc(currentUser.uid)
          .collection("Books")
          .doc(book.bookid)
          .collection("Bookmarks")
          .doc(newID)
          .set({
            id: newID,
            excerpt: book.excerpt,
            location: book.location,
            position: book.position,
            bookid: book.bookid
          })
          .then(res => resolve(res), err => reject(err));
      } catch (error) {
        console.error(error);
      }
    });
  }


  /**
    *Recupera le informazioni dell'utente loggato
    *
    * @param {IUserSubData} user
    * @returns {Observable<IUserSubData[]>}
    * @memberof FirebaseService
    */
  getHighlightByBookId(bookid: string): Observable<ImyBookHighlight[]> {
    let currentUser = firebase.auth().currentUser;

    this.itemsCollectionHighlightData = this.afs
      .collection("UserData")
      .doc(currentUser.uid)
      .collection("Books")
      .doc(bookid)
      .collection("Highlight");
    this.itemsHighlightData = this.itemsCollectionHighlightData.valueChanges();

    return this.itemsHighlightData.pipe(
      map((res: ImyBookHighlight[]) => {
        return res;
      })
    );
  }

  /**
  * Elimina il Libro dalla propria libreria
  * @param book
  */
  RemoveMyHighlight(book: ImyBookHighlight) {
    return new Promise<any>((resolve, reject) => {
      let currentUser = firebase.auth().currentUser;
      this.afs
        .collection("UserData")
        .doc(currentUser.uid)
        .collection("Books")
        .doc(book.bookid)
        .collection("Highlight")
        .doc(book.id)
        .delete()
        .then(res => resolve(res), err => reject(err));
    }).then(function () {
      console.log("Document successfully written!");
    })
      .catch(function (error) {
        console.error("Error writing document: ", error);
      });
  }

  /**
  * Aggiorna i dati inerenti al libro che si ha appena chiuso (Colore,font,ultima pagina,ecc...)
  * @param book Libro da aggrionare
  */
  UpdateMyHighlight(book: ImyBookHighlight) {
    return new Promise<any>((resolve, reject) => {
      try {
        let currentDate = new Date();
        let currentUser = firebase.auth().currentUser;
        let newID: string = this.afs.createId();
        this.afs
          .collection("UserData")
          .doc(currentUser.uid)
          .collection("Books")
          .doc(book.bookid)
          .collection("Highlight")
          .doc(newID)
          .set({

            id: newID,
            text: book.text,
            location: book.location,
            position: book.position,
            cfiRange: book.cfiRange,
            bookid: book.bookid
          })
          .then(res => resolve(res), err => reject(err));
      } catch (error) {
        console.error(error);
      }
    });
  }

  //-----------------------------------------------------------------------------------------------------------
}
// unsubscribeOnLogOut() {
//   //remember to unsubscribe from the snapshotChanges
//   // debugger;

//   this.snapshotChangesSubscription.unsubscribe();
// }

// updateTask(taskKey, value) {
//   return new Promise<any>((resolve, reject) => {
//     let currentUser = firebase.auth().currentUser;
//     this.afs
//       .collection("people")
//       .doc(currentUser.uid)
//       .collection("tasks")
//       .doc(taskKey)
//       .set(value)
//       .then(res => resolve(res), err => reject(err));
//   });
// }

// deleteTask(taskKey) {
//   return new Promise<any>((resolve, reject) => {
//     let currentUser = firebase.auth().currentUser;
//     this.afs
//       .collection("people")
//       .doc(currentUser.uid)
//       .collection("tasks")
//       .doc(taskKey)
//       .delete()
//       .then(res => resolve(res), err => reject(err));
//   });
// }

// createTask(value) {
//   return new Promise<any>((resolve, reject) => {
//     let currentUser = firebase.auth().currentUser;
//     this.afs
//       .collection("people")
//       .doc(currentUser.uid)
//       .collection("tasks")
//       .add({
//         title: value.title,
//         description: value.description,
//         image: value.image
//       })
//       .then(res => resolve(res), err => reject(err));
//   });
// }

// encodeImageUri(imageUri, callback) {
//   var c = document.createElement("canvas");
//   var ctx = c.getContext("2d");
//   var img = new Image();
//   img.onload = function() {
//     var aux: any = this;
//     c.width = aux.width;
//     c.height = aux.height;
//     ctx.drawImage(img, 0, 0);
//     var dataURL = c.toDataURL("image/jpeg");
//     callback(dataURL);
//   };
//   img.src = imageUri;
// }

// uploadImage(imageURI, randomId) {
//   return new Promise<any>((resolve, reject) => {
//     let storageRef = firebase.storage().ref();
//     let imageRef = storageRef.child("image").child(randomId);
//     this.encodeImageUri(imageURI, function(image64) {
//       imageRef.putString(image64, "data_url").then(
//         snapshot => {
//           snapshot.ref.getDownloadURL().then(res => resolve(res));
//         },
//         err => {
//           reject(err);
//         }
//       );
//     });
//   });
// }



// WEBPACK FOOTER //
// ./src/services/firebase.service.ts